import React from 'react';
import FieldError from './FieldError';

interface PhoneInputProps {
    value: string;
    error: string;
    onChange: (value: string) => void;
    onBlur: () => void;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ value, error, onChange, onBlur }) => (
    <div className="cf-field">
        <input
            type="tel"
            className={`cf-input${error ? ' cf-input--error' : ''}`}
            placeholder="טלפון"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            id="cf-phone"
            dir="ltr"
        />
        <FieldError message={error} />
    </div>
);

export default PhoneInput;
